<template>
  <SummarySection title="Vendeur" @edit="$emit('edit')">
    <p class="mt-1 text-sm text-gray-700">{{ sellerCompleteName }}</p>
  </SummarySection>
</template>

<script>
import SummarySection from "./SummarySection.vue";

export default {
  components: { SummarySection },
  emits: ["edit"],
  props: {
    sellerCompleteName: {
      type: String,
      required: true,
    },
  },
};
</script>
